import { PageHeader,  Tag, Layout, Col, Row, Dropdown, Menu, Button } from 'antd'
import { EllipsisOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom';
import {getStudentreports} from '../actions/studentreport';
import {getAttendances} from '../actions/attendance';
import Loading from './Loading';


let {Content} = Layout

const color = "teal"

const Index = (props) => {

const history = useNavigate()

const store_data = localStorage.getItem('selectedresult') !== null && localStorage.getItem('selectedresult') !== undefined ? JSON.parse(localStorage.getItem('selectedresult')) : {}
const reportinfo = store_data.data || {};
const schoolinfo = store_data.schooldata  || {};
const claszinfo = store_data.classdata || {};

const [reports, setreports] = useState(reportinfo)
//const [claszs, setclaszs] = useState(claszinfo)
const [arr_reports, setarr_reports] = useState([])
const [useLoading, setuseLoading] = useState(false)

const get_rows = async (id, arrays) =>{
    if(arrays.hasOwnProperty(id)){
       return await arrays[id]
    }
    return null
}

useEffect(() => {
    setuseLoading(true)
    let vals = []
    Object.keys(props.reports).forEach(schoolid=>{
        let sessions = props.reports[schoolid]
        Object.keys(sessions).forEach(sessionid=>{
            let terms = sessions[sessionid]
            Object.keys(terms).forEach(termid=>{
                let claszs = terms[termid]
                Object.keys(claszs).forEach(claszid=>{
                    let reps = claszs[claszid]
                    Object.keys(reps).forEach(repid=>{
                        let rep_data = reps[repid]
                        let arr = {}
                        let sch = props.schools[schoolid]
                        let cla = props.claszs[parseInt(claszid)]
                        arr['schoolname'] = sch !== null ?  sch?.abbrv : ''
                        arr['classname'] =  cla !== null ? cla?.name : ''
                        arr['reportname'] = rep_data.title
                        arr['schooldata'] = sch
                        arr['classdata'] = cla
                        arr['data'] = rep_data
                        vals.push(arr)
                    })
                })
            })              
        })
    })
    setarr_reports(vals)
    setuseLoading(false)
}, [props.reports, props.schools, props.claszs])
 
    const loadResult = (d) =>{
        let reps = d.data
        localStorage.setItem('selectedresult', JSON.stringify(d))
        let repid = reps.id | null
        setreports(reps)
        if(parseInt(repid) > 0 && Array.isArray(Object.keys(reps)) && Object.keys(reps).length > 0)
        {
            //GET ALL rep FOR THE STUDENTS
            let cas = reps.ca || '';
            let terms = reps.termid || '';
            let sessions = reps.sessionid || '';
            let grd = reps.grade || '';
            let stg = reps.stage || '';
            let cv = parseInt(stg) === 1 ? cas : repid;
            let params = {
            data:JSON.stringify(
            {
                  'sessionid':sessions,
                  'reportid':cv,
                  'termid':terms,
                  'stage':stg,
                  'cas' : cas,
                  'gradeid' : grd,
                  'studentid' : props.mid
              }),
              cat:'selectreportmain',
              table:'studentscore',
              narration:'get reports'
            }
            props.getStudentreports(params)
            loadResultAttendance(d)
        }

        let {sessionid:id} =  d.data ||  null
        history(`./fee/${id}`, {state:d})

    }
    const loadResultAttendance = (d) =>{
        let reps = d.data
        let term = reps.termid || '';
        let session = reps.sessionid || '';
        let params = {
            data:JSON.stringify(
            {
                  'sessionid':session,
                  'termid':term,
                  'studentid' : props.mid
              }),
              cat:'selected_attendance',
              table:'studentscore',
              narration:'get attendances'
            }
            props.getAttendances(params)

    }
    const menu = (
        <Menu>
            {
                arr_reports.map((prop, index)=>{
                    return <Menu.Item 
                        key={index} 
                        onClick={()=>loadResult(prop)}
                    >
                      {`${prop.schoolname} ${prop.classname} ${prop.reportname}`}
                  </Menu.Item>
                })
            }
        </Menu>
      ); 

    const DropdownMenu = () => (
        <Dropdown key="more" overlay={menu}>
          <Button>
            <EllipsisOutlined
              style={{
                fontSize: 20,
                verticalAlign: 'top',
              }} 
            /> Select Report
          </Button>
        </Dropdown>
    );
   
 const datas = Array.isArray(arr_reports) && arr_reports.length > 0 ? arr_reports : []
 datas.forEach(element => {
     console.log(element)
 });
  return (
    <Layout>
         <PageHeader
                title="Fees"
                className="site-page-header no-print"
                subTitle="Student Report Card"
                tags={<Tag color="blue">Active</Tag>}
                extra={[
                    <DropdownMenu key="more" />,
                ]}
                avatar={{ src: process.env.PUBLIC_URL+'/asset/icons/report.png' }}     
            >
            </PageHeader>
         <Content >
             {!props.isLoading && !useLoading ?
            <Row xs={12} style={{display:'flex', flexDirection:'row', width:"100%", flexWrap:'wrap', alignContent:'center', WebkitAlignContent:'center'}}>
            {
                Array.isArray(datas) ? 
                datas.map((p, i)=>{
                    return  <Col key={i} md={6} onClick={()=>loadResult(p)}>
                            <div
                                style={{
                                    backgroundColor:'#ffffff',
                                    backgroundImage: `radial-gradient(circle at top right, ${color}, white 20% )`,
                                    border:`4px solid ${color}`,
                                    margin:"10px",
                                    padding: '20px',            
                                    display:'flex',
                                    flexDirection:'column',
                                    textAlign:'left',
                                    boxShadow: "0 0 5px 2px rgba(0,0,0,.35)"
                                }}
                            >
                                <span className='card_text' style={{display:'block', fontWeight:'bold'}}>{p.reportname}</span>
                                <span style={{display:'block'}}>{p.classname}</span>
                            </div>
                    </Col>
                }):null
            }
            </Row>:
            <Loading />
}
        </Content>
    </Layout>
  )
}

const mapStateToProps = (state) => ({
    reports:state.reportReducer.reports,
    attendance:state.attendanceReducer.attendances,
    schools:state.reportReducer.schools,
    claszs:state.reportReducer.claszs,
    studentreport:state.studentreportReducer.studentreports,
    isLoading:state.studentreportReducer.isLoading,
    mid:state.userReducer.mid
})

const mapDispatchToProps = {
    getStudentreports,
    getAttendances
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)

